  export module Ajax {
    export class Options {
        url: string;
        method: string;
        data: object |FormData;
        contentType: string | false;
        processData: boolean;
        dataType: string;

        constructor(url: string, method?: string, data?: object | FormData, dataType?: string, contentType?: string | false, processData?: boolean) {
            this.url = url;
            this.method = method || "get";
            this.data = data || {};
            this.dataType = dataType || "html";
            this.contentType = contentType ?? "application/x-www-form-urlencoded; charset=UTF-8";
            this.processData = processData ?? true;
        }
    }

    export class Service {
        public request = (options: Options, successCallback: Function, errorCallback?: Function): JQuery.jqXHR<any> => {
            var that = this;
            return $.ajax({
                url: options.url,
                type: options.method,
                data: options.data,
                dataType: options.dataType,
                contentType: options.contentType,
                processData: options.processData,
                cache: false,
                success: function (d) {
                    successCallback(d);
                },
                error: function (d) {
                    if (errorCallback) {
                        errorCallback(d, options);
                        return;
                    }
                    var errorTitle = "Error in (" + options.url + ")";
                    var fullError = JSON.stringify(d);
                    console.error(errorTitle);
                    console.error(fullError);
                    that.showAlert(fullError, errorTitle);
                }
            });
        }
        public get = (url: string, successCallback: Function, errorCallback?: Function): void => {
            this.request(new Options(url), successCallback, errorCallback);
        }
        public getWithData = (url: string, data: Object, successCallback: Function, errorCallback?: Function): void => {
            this.request(new Options(url, "get", data), successCallback, errorCallback);
        }
        public post = (url: string, successCallback: Function, errorCallback?: Function): void => {
            this.request(new Options(url, "post"), successCallback, errorCallback);
        }
        public postWithData = (url: string, data: Object, successCallback: Function, errorCallback?: Function): void => {
            this.request(new Options(url, "post", data), successCallback, errorCallback);
        }

        public showAlert = (message: string, title?: string): void => {
            alert(title + "\n" + message);
        }
    }
}